import { isFunction } from 'lodash';

import { Button } from '@/components/button';
import { Landing } from '@/components/modules/landing';

export interface ShipmentErrorProps {
  message?: string;
  onBack?: () => void;
}

const ShipmentError = ({ message, onBack }: ShipmentErrorProps) => {
  return (
    <Landing
      heading="An error occurred fetching the details of this shipment."
      subHeading="Please wait a minute and try refreshing the page, if this error continues to occur please let us know at contact@fluentcargo.com."
      footerText={message || 'Error 500'}
      imageUrl="https://www.datocms-assets.com/52833/1718339394-shipment-placeholder.png"
      imageAlt="shipment not found"
      variant="basic"
      imageWidth={300}
      order="reverse"
      actions={isFunction(onBack) ? <Button onClick={onBack}>Back to shipments</Button> : null}
    />
  );
};

export { ShipmentError };
